import {HOST} from '../config'
import axios from "axios";
import qs from "qs";


// const token = sessionStorage.getItem('access_token');
const token = localStorage.getItem('access_token');


//로그인
export async function loginAPI(userid, password){
    const params = {
        "userid": userid,
        "password": password,
    }
    try {
        const res = await axios.post(`${HOST}/user/login`, qs.stringify(params))
        return res.data.data;
    } catch (err) {
        return null;
    }
}

//유저정보
export async function getUserInfo(token){
    try {
        const res = await axios.get(`${HOST}/user/info`, { headers:{Authorization: `Bearer ${token}`} })
        return res.data.data;
    } catch (err) {
        logoutAPI().then(res =>{
            localStorage.clear();
            document.location.replace("/")
            })
    }
}

//로그아웃
export async function logoutAPI(){
    try {
        const res = await axios.delete(`${HOST}/user/logout`, { headers: {Authorization: `Bearer ${token}`}})
        return res.data;
    } catch (err) {
        return null;
    }
}


//이메일 인증 요청
export async function emailAuthAPI(email){
    const params = {
        userid: email,
    }
    try {
        const res = await axios.post(`${HOST}/user/send/emailauth`, qs.stringify(params))
        return res.data;
    } catch (err) {
        return null;
    }
}

//회원가입
export async function joinAPI(info){
    try {
        const res = await axios.post(`${HOST}/user/join`, qs.stringify(info))
        return res.data;
    } catch (err) {
        return null;
    }
}


/************ SETTING PAGE ***************/
//유저 세팅 설정값 조회
export async function getSettingInfo(){
    try {
        const res = await axios.get(`${HOST}/user/push/status`,{ headers:{Authorization: `Bearer ${token}`} })
        return res.data.data;
    } catch (err) {
        return null;
    }
}


//유저 세팅값 수정
export async function editSettingInfo(type, status){
    try {
        const res = await axios.put(`${HOST}/user/push/status/${type}/${status}`,{},{ headers:{Authorization: `Bearer ${token}`}})
        // const res = await axios.put(`${HOST}/user/push/status/03/N`,{},{ headers:{Authorization: `Bearer ${token}`}})
        if(res.data.resultcode === '200'){
            return res.data.data;
        } else {
            return null
        }
    } catch (err) {
        return null;
    }
}


export async function editSettingTime(type, status, start, end){
    const params = {
        alertsettype: type,
        agree: status,
        alertstime: start,
        alertetime: end,
    }

    try {
        const res = await axios.post(`${HOST}/user/push/status/alert`,qs.stringify(params),{ headers:{Authorization: `Bearer ${token}`}})
        if(res.data.resultcode === '200'){
            return res.data.data;
        } else {
            return null
        }
    } catch (err) {
        return null;
    }
}